import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onClick"];
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UITypeahead from 'UIComponents/typeahead/UITypeahead';
import I18n from 'I18n';
import KnowledgePopoverEmptyState from './draft-content-transplant-ka/KnowledgePopoverEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LoadingSpinner = styled(UILoadingSpinner).withConfig({
  displayName: "MultiKBTypeaheadContainer__LoadingSpinner",
  componentId: "sc-1fel8t9-0"
})(["align-items:center;display:flex;height:180px;justify-content:center;"]);
const StyledKBResultItem = styled.li.withConfig({
  displayName: "MultiKBTypeaheadContainer__StyledKBResultItem",
  componentId: "sc-1fel8t9-1"
})(["display:flex;align-items:center;*:first-child{flex-grow:1;}"]);
const KBResultItem = _ref => {
  let {
      children,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(StyledKBResultItem, Object.assign({}, rest, {
    children: [children, /*#__PURE__*/_jsx(UIIconButton, {
      use: "transparent",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "right",
        size: "small",
        onClick: onClick
      })
    })]
  }));
};
const MultiKBTypeaheadContainer = ({
  onChange,
  onSearchChange,
  portalId,
  kbsAreLoading,
  options,
  searchQuery,
  searchIsLoading
}) => {
  if (kbsAreLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  if (!kbsAreLoading && searchQuery.length === 0 && options.length === 0) {
    return /*#__PURE__*/_jsx(KnowledgePopoverEmptyState, {
      portalId: portalId
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UITypeahead, {
      autoFilter: false,
      hideResults: searchIsLoading,
      itemComponent: searchQuery.length === 0 ? KBResultItem : undefined,
      options: options,
      onChange: onChange,
      onSearchChange: onSearchChange,
      placeholder: I18n.text('hubspot-prosemirror.knowledgeBase.search.placeholder')
    }), searchIsLoading && /*#__PURE__*/_jsx(LoadingSpinner, {})]
  });
};
export default MultiKBTypeaheadContainer;